/**
 * Enum for pathway types/categories.
 * Used to identify and categorize different types of treatment pathways.
 */
export enum PathwayType {
  /** Procreazione Medicalmente Assistita (Assisted Reproductive Technology) */
  PMA = "PMA",

  /** Social Freezing for males */
  SOCIAL_FREEZING_MALE = "SOCIAL_FREEZING_MALE",

  /** Social Freezing for females */
  SOCIAL_FREEZING_FEMALE = "SOCIAL_FREEZING_FEMALE",

  /** Fertility check-in for males */
  FERTILITY_CHECKIN_MALE = "FERTILITY_CHECKIN_MALE",

  /** Fertility check-in for females */
  FERTILITY_CHECKIN_FEMALE = "FERTILITY_CHECKIN_FEMALE",

  /** Benessere Fertile for males */
  BENESSERE_FERTILE_MALE = "BENESSERE_FERTILE_MALE",

  /** Benessere Fertile for females */
  BENESSERE_FERTILE_FEMALE = "BENESSERE_FERTILE_FEMALE",

  /** Other */
  OTHER = "OTHER"
}
